<template lang="pug">
  #scatter
    .row
      .col-12.col-lg-9
        .d-flex.flex-row.justify-content-center.align-items-center
          b-form-select(v-model="selected" :options="options" @change="updateLayer")
          p.mb-0.ml-2.large.bold vs. población vulnerable* en México

        ch3s1_01#scatter-plot
      .col-12.col-lg-3.scatter-info
        ScatterSelection

</template>
<script>
import * as d3 from "d3";
import ch3s1_01 from "@/assets/chapter3/ch3s1_01.vue";
import ScatterSelection from "./ScatterSelection.vue";

export default {
  name: "Scatter",
  components: {
    ch3s1_01,
    ScatterSelection
  },
  data() {
    return {
      options: [
        {
          text: "Infraestructura hospitalaria (camas)",
          value: "Infraestructura_Hospitalaria"
        },
        {
          text: "Personal médico y especialistas",
          value: "Personal_Médico"
        },
        {
          text: "Personal de enfermería",
          value: "Personal_Enfermería"
        },
        {
          text: "Hospitales",
          value: "Hospitales"
        }
      ],
      selected: "Infraestructura_Hospitalaria"
    };
  },
  computed: {
    selectedState: {
      get() {
        return this.$store.state.ch3SelectedState;
      },
      set(value) {
        this.$store.state.ch3SelectedState = value;
      }
    }
  },
  methods: {
    hover(chart, elements, lighterSelection = true) {
      d3.selectAll("#" + chart + " " + elements)
        .on("mouseover", function() {
          if (lighterSelection) {
            d3.select("#" + chart.toLowerCase())
              .selectAll(elements)
              .style("opacity", 1);

            d3.select(this).style("opacity", 0.7);
          } else {
            d3.select("#" + chart.toLowerCase())
              .selectAll(elements)
              .style("opacity", 0.65);

            d3.select(this).style("opacity", 1);
          }
        })
        .on("mouseout", function() {
          d3.select("#" + chart.toLowerCase())
            .selectAll(elements)
            .style("opacity", 1);
        });
    },
    groupTransition(chart, layerSelected, otherLayers) {
      if (Array.isArray(layerSelected)) {
        for (let i = 0; i < layerSelected.length; i++) {
          d3.select("#" + chart + " #" + layerSelected[i])
            .transition()
            .duration(550)
            .style("display", "block")
            .style("opacity", 1);
        }
      } else {
        d3.select("#" + chart + " #" + layerSelected)
          .transition()
          .duration(550)
          .style("display", "block")
          .style("opacity", 1);
      }
      if (Array.isArray(otherLayers)) {
        for (let i = 0; i < otherLayers.length; i++) {
          d3.select("#" + chart + " #" + otherLayers[i])
            .transition()
            .duration(550)
            .style("display", "none")
            .style("opacity", 0);
        }
      } else {
        d3.select("#" + chart + " #" + otherLayers)
          .transition()
          .duration(550)
          .style("display", "none")
          .style("opacity", 0);
      }
    },
    namesTransition(chart, layerSelected, otherLayers) {
      if (Array.isArray(layerSelected)) {
        for (let i = 0; i < layerSelected.length; i++) {
          d3.selectAll("#" + chart + " #" + layerSelected[i] + " .names text")
            .transition()
            .duration(500)
            .delay((d, i) => 750 + i * 600)
            .style("opacity", "1");
        }
      } else {
        d3.selectAll("#" + chart + " #" + layerSelected + " .names text")
          .transition()
          .duration(300)
          .delay((d, i) => i * 50)
          .style("opacity", "1");
      }
      if (Array.isArray(otherLayers)) {
        for (let i = 0; i < otherLayers.length; i++) {
          d3.selectAll(
            "#" + chart + " #" + otherLayers[i] + " .names text"
          ).style("opacity", "0");
        }
      } else {
        d3.selectAll("#" + chart + " #" + otherLayers + " .names text").style(
          "opacity",
          "0"
        );
      }
    },
    selectState() {
      const vm = this;
      d3.selectAll("#scatter-plot .state").on("click", function() {
        vm.selectedState = this.dataset.id;
      });
    },
    updateLayer() {
      const layers = [
        "Infraestructura_Hospitalaria",
        "Personal_Médico",
        "Personal_Enfermería",
        "Hospitales"
      ];
      let others = layers.filter(l => l !== this.selected);
      this.groupTransition("scatter-plot", this.selected, others);
      //this.namesTransition("scatter-plot", this.selected, others);
    }
  },
  mounted() {
    this.hover("scatter-plot", ".state", false);
    this.selectState();
  }
};
</script>

<style lang="scss">
#scatter {
  .scatter-info {
    background-color: #0a1d59;
  }
}
</style>
